import convertStringToSlug from '../convertStringToSlug';

const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;

const slugNewsFormatter = (article: any) => {
  let url = '';
  const citySlug = convertStringToSlug(article.city?.name);
  switch (article.articleType) {
    case 'city':
      url = `${PUBLIC_URL}/dealer-toyota/${citySlug}/berita-dan-tips/${article.slug}`;
      break;
    case 'branch':
      url = `${PUBLIC_URL}/dealer-toyota/${citySlug}/${article.branch?.branchLandingPage?.seoSlug}/berita-dan-tips/${article.slug}`;
      break;
    case 'national':
      url = `${PUBLIC_URL}/berita-dan-tips/${article.slug}`;
      break;
    default:
      break;
  }
  return url;
};

export default slugNewsFormatter;
